import { FC, ReactNode } from "react";

import { Icon } from "../../../general";
import { Body } from "../../../typography";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly errorMessage: ReactNode;
}

/** Error banner announced to screen readers, attached to the top of the chat input. Retrying is offered by the input's submit button. */
export const ErrorNotice: FC<Props> = ({ styles, errorMessage }) => (
  <div className={styles.ErrorNotice} role="alert">
    <Icon name="x-circle" className={styles.ErrorNoticeIcon} aria-hidden="true" />
    <Body>{errorMessage}</Body>
  </div>
);
